<div class="ag-overlay-loading-center">
  <mat-progress-spinner
    [color]="'primary'"
    [diameter]="diameter"
    [mode]="'indeterminate'"
  ></mat-progress-spinner>
</div>
